

























































































import {
  computed,
  watch,
  defineComponent,
  ref,
  Ref,
  reactive,
  onUnmounted,
  getCurrentInstance,
} from '@vue/composition-api';
import { BaseTableCol } from 'tdesign-vue';
import { CheckCircleFilledIcon, CloseCircleFilledIcon } from 'tdesign-icons-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import openPreviewHandler from '@/renderer/components/SpacePage/compositions/openPreviewHandler';
import smh from '@/renderer/scripts/smh';
import storage from '@/renderer/scripts/utils/storage';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { ListDownloadLogTaskContentItem } from '../compositions/listHandler';
export default defineComponent({
  components: {
    CheckCircleFilledIcon,
    CloseCircleFilledIcon,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    localTransferList: {
      type: Object,
      required: true,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    enum TabName {
      Exporting,
      Exported,
    }
    const currentTabName: Ref<TabName> = ref(TabName.Exporting);
    const cloudTransferList = reactive<{
      exporting: ListDownloadLogTaskContentItem[];
      exported: ListDownloadLogTaskContentItem[];
    }>({
      exporting: [],
      exported: [],
    });
    const hasNewExported = ref(false);

    /**
     * @description 获取保存至网盘的日志列表
     */
    const pullCloudList = async () => {
      const isFirstPull = !(cloudTransferList.exported.length || cloudTransferList.exporting.length);
      const beforeExportedLength = cloudTransferList.exported.length;
      try {
        const { data } = await smh.userAPI.listDownloadLogTask();
        const { contents } = data;

        // 清空已存在的数据
        cloudTransferList.exporting = [];
        cloudTransferList.exported = [];
        contents.forEach(before => {
          const finishedStatus = [200, 404, 500];
          const isExported = finishedStatus.includes(before.status);
          const name = isExported && before.result ? before.result.fileName || before.label : before.label;
          const after: ListDownloadLogTaskContentItem = {
            name,
            status: before.status,
            total: before.total,
            remaining: before.remaining,
            target: 'cloud',
            taskId: before.taskId,
            creationTime: before.creationTime,
            ...(before.result && {
              spaceId: before.result.spaceId || '',
              path: before.result.path,
              teamId: before.result.teamId,
              userId: before.result.userId,
            }),
          };
          if (isExported) {
            cloudTransferList.exported.push(after);
          } else {
            cloudTransferList.exporting.push(after);
          }
        });
        hasNewExported.value = !isFirstPull && cloudTransferList.exported.length > beforeExportedLength;
      } catch (e) {
        tips.error(e as MsgError);
      }
    };
    let pullListTimer: any = null;
    const setMyInterval = (func: Function, wait: number) => {
      const interv = () => {
        func.call(null);
        pullListTimer = setTimeout(interv, wait);
      };
      pullListTimer = setTimeout(interv, wait);
    };

    /**
     * @description 取消轮询云端日志列表接口
     */
    const cancelPollingPullCloudList = () => {
      pullListTimer && clearTimeout(pullListTimer);
      pullListTimer = null;
    };

    /**
     * @description 开始轮询云端日志列表接口
     */
    const beginPollingPullCloudList = () => {
      pullCloudList();
      setMyInterval(() => {
        pullCloudList();
      }, 5000);
    };
    watch(
      () => innerShow.value,
      (val, oldVal) => {
        cancelPollingPullCloudList();
        if (val) {
          beginPollingPullCloudList();
        }
      },
    );
    watch(
      () => currentTabName.value,
      val => {
        if (val === TabName.Exported) {
          hasNewExported.value = false;
        }
      },
    );
    const tabelColumns = computed(() => {
      const columns: BaseTableCol[] = [
        {
          colKey: 'name',
          title: i18n_t('文件名'),
        },
        {
          colKey: 'status',
          title: i18n_t('状态'),
          width: 150,
        },
        {
          colKey: 'action',
          title: i18n_t('操作'),
          width: 110,
        },
      ];
      return columns;
    });

    /**
     * @description 表格中展示的数据，由导出到网盘和导出到本地组成
     */
    const tabelData = computed(() => {
      if (currentTabName.value === TabName.Exporting) {
        return [...props.localTransferList.exporting, ...cloudTransferList.exporting];
      }
      return [...props.localTransferList.exported, ...cloudTransferList.exported];
    });
    const openDirectory = async (row: ListDownloadLogTaskContentItem) => {
      const { target, spaceId, path, teamId } = row;
      if (target === 'cloud') {
        const isTeamSpace = teamId !== undefined;
        const routerName = isTeamSpace ? 'teamSpace' : 'personalSpace';
        if (isTeamSpace) {
          const res = await smh.userAPI.queryTeam({
            teamId: teamId as number,
            withPath: true,
          });
          storage.set(storage.StoreKey.TEAM_PATH, {
            spaceId,
            path: res.data.path || [],
          });
        }
        storage.set(storage.StoreKey.REMOTE_PATH, {
          routerName,
          remoteFolder: path ? path.join('/') : '',
          spaceId,
          teamId,
          path,
        });
        dispatchRouter(
          {
            name: 'transit',
          },
          'replace',
        );
      }
    };
    const deleteItem = async (row: ListDownloadLogTaskContentItem) => {
      const { target, taskId } = row;
      if (target === 'cloud') {
        try {
          const { status } = await smh.userAPI.deleteTask({
            taskId,
          });
          if (status === 204) {
            tips.success(i18n_t('删除成功'));
          } else {
            tips.error(i18n_t('删除失败'));
          }
          cancelPollingPullCloudList();
          beginPollingPullCloudList();
        } catch (e) {
          tips.error(e as MsgError);
        }
      } else {
        const getTaskId = (item: ListDownloadLogTaskContentItem) => item.taskId === taskId;
        let index = props.localTransferList.exported.findIndex(getTaskId);
        if (index === -1) {
          index = props.localTransferList.exporting.findIndex(getTaskId);
          props.localTransferList.exporting.splice(index, 1);
        } else {
          props.localTransferList.exported.splice(index, 1);
        }
      }
    };
    const deleteAll = () => {
      cloudTransferList.exported.forEach(item => {
        deleteItem(item);
      });
    };
    const previewItemSpaceId = ref('');
    const { methods: previewMethods } = openPreviewHandler(previewItemSpaceId);
    const previewItem = (row: ListDownloadLogTaskContentItem) => {
      if (currentTabName.value === TabName.Exporting) {
        return;
      }
      const { spaceId, name, creationTime, path } = row;
      spaceId && (previewItemSpaceId.value = spaceId);
      const item = {
        name,
        type: 'csv',
        previewByDoc: true,
        creationTime,
        path: (path as string[]).concat([name]),
      };
      previewMethods.openPreview(item, 0);
    };
    onUnmounted(() => {
      // 取消计时器
      cancelPollingPullCloudList();
    });
    return {
      innerShow,
      TabName,
      currentTabName,
      pullCloudList,
      tabelColumns,
      tabelData,
      cloudTransferList,
      hasNewExported,
      openDirectory,
      deleteItem,
      deleteAll,
      previewItem,
    };
  },
});
